import { Component, Input, OnInit, OnChanges, PLATFORM_ID, Inject, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChild } from "@angular/core";
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { VgStates, VgEvents, VgAPI, VgFullscreenAPI } from 'videogular2/core';
import { VgPlayPause } from 'videogular2/src/controls/vg-play-pause/vg-play-pause';
import { VgMute } from 'videogular2/src/controls/vg-mute/vg-mute';
import { VgVolume } from 'videogular2/src/controls/vg-volume/vg-volume';
import { VgScrubBarCurrentTime } from 'videogular2/src/controls/vg-scrub-bar/vg-scrub-bar-current-time/vg-scrub-bar-current-time';
import { VgScrubBarBufferingTime } from 'videogular2/src/controls/vg-scrub-bar/vg-scrub-bar-buffering-time/vg-scrub-bar-buffering-time';
import { VgScrubBar } from 'videogular2/src/controls/vg-scrub-bar/vg-scrub-bar';
import { VgTimeDisplay } from 'videogular2/src/controls/vg-time-display/vg-time-display';
import { VgOverlayPlay } from 'videogular2/src/overlay-play/vg-overlay-play';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Subscription } from 'rxjs/Subscription';
import { IMediaStream } from '../../model/app.models';
import { ActivatedRoute } from '@angular/router';
import { Angulartics2Vdgm } from 'angular-engine/engine/providers/Angulartics2Vdgm';
import { Subject } from 'rxjs/Subject';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { DEVICE_INFO, APP_SETTINGS, DeviceInfo, MediaStream } from 'angular-engine/modules/ng-express-engine/tokens';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { UserLoginService } from 'angular-engine/engine/service/user/user.login.service';
import { VgOverlayPoster } from './controls/video-player-poster.component';
import { VgTheatreMode } from "./controls/vg-theatre-mode/vg-theatre-mode.component";
import { VideoPlayerControlService } from "angular-engine/engine/service/ui/videoplayer/videoplayer-control.service";
import 'rxjs/add/operator/first';


declare let Hls;
declare let chrome;
declare let cast;
declare let ActiveXObject;

@Component({
    selector: 'video-player',
    templateUrl: './video-player.template.html',
    styleUrls: ['./video-player.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush

})
export class VideoPlayer implements OnInit {
    @Input() sources: Array<IMediaStream>;
    @Input() slug: string;
    @Input() poster: string;
    @Input() description: string;
    @Input() snipe: string;
    @Input() upnext: any;
    @Input() title: string;
    @Input() embed: boolean;
    @Input() logo: string;
    @Input() meta: any;
    @Input() media: any;
    @Input() cMedia: any;
    @Input() timestamp: number;
    @Input() activeMedia: string = "singleVideo";
    @Input() small: boolean;
    @Input() timeFormat: string;
    @Input() prevDurationWatched;
    @Input() prevPercentPlayed;
    
    private requiresPrompt: boolean = false;
    protected flashInstalled: boolean = false;
    private time: number;
    protected duration: number = 0;
    private playing: boolean = false;
    private ended: boolean = false;
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    private percentPlayed: number = .05;
    public isChrome: boolean = false;
    private canCast: boolean = false;
    public isCasting: boolean = false;
    private needsCasting: boolean = false;
    private chromeCastInited: boolean = false;
    private previousSession: boolean = false;
    private startCastingDispatched = false;
    private connectionAttempts = 10;
    private cCastSubscription: Subscription;
    private autoplaySubscription: Subscription;
    //private needsCastingSubscription: Subscription;
    //private favoriteSubscription: Subscription;
    private autoplay = true;
    private inTransition: boolean = false;
    //private likeSubscription : Subscription;
    //private timestampSubscription : Subscription;
    private liveDurationWatched: number = 0;
    private mediaPlayed: boolean = false;
    public thumbSlice: number = 10;
    public isTheatreMode : boolean = false;

    @Input() promptPlayback: boolean = false;
    @Input() likeStatus = null;
    @ViewChild('playPause') playPause: VgPlayPause;
    @ViewChild('current') current: VgTimeDisplay;
    @ViewChild('total') total: VgTimeDisplay;
    @ViewChild('overlayPlay') overlayPlay: VgOverlayPlay;
    @ViewChild('scrubBar') scrubBar: VgScrubBar;
    @ViewChild('scrubTime') scrubTime: VgScrubBarCurrentTime;
    @ViewChild('bufferTime') bufferTime: VgScrubBarBufferingTime;
    @ViewChild('volume') volume: VgVolume;
    @ViewChild('mute') mute: VgMute;
    @ViewChild('vidPoster') vidPoster: VgOverlayPoster;
    @ViewChild('media') video: any;
    @ViewChild('theatre') theatreControl:VgTheatreMode;

    api: VgAPI;
    isClient: boolean;

    constructor(
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        @Inject(APP_SETTINGS) private settings: Object,
        protected coreEffects: CoreEffects,
        protected userLogin: UserLoginService,
        private analytics: Angulartics2Vdgm,
        private route: ActivatedRoute,
        private interactions: EventInteraction,
        private cd: ChangeDetectorRef,
        private playerService: VideoPlayerControlService
    ) {
        this.isClient = isPlatformBrowser(this.platformId);

        this.thumbSlice = settings['VIDEO_THUMBNAILS_CHUNK'];
        
        if (this.isClient) {
            this.isChrome = this.deviceInfo.userAgent.toLowerCase().indexOf("chrome") > -1;
            //this.isChrome = false;
            
            if (typeof window.navigator.plugins !== 'undefined' && typeof window.navigator.plugins['Shockwave Flash'] === 'object') {
                this.flashInstalled = true;
            }

            const self = this;            
            
            this.autoplaySubscription = this.interactions.subscribe(e => {
                if (e.key === "autoplay") {
                    this.autoplay = e.message.autoplay ;
                    if (this.autoplay){
                        this.media.state = VgStates.VG_PAUSED;
                        this.media.play();
                        this.mediaPlayed = true;
                    }
                }

                if (e.key === "needsCasting") {
                    //console.log("cc said it needs casting");
                    this.startCastingDispatched = true;
                    this.interactions.next({ key: "startCasting", message: { startCasting: true } });
                }

                if( e.key === "vg-like"){
                    self.likeStatus = e.message;
                    self.updateVideoStats();
                }

                if( e.key === "start-video"){
                   this.media.seekTime(Number(e.message));
                   this.media.play();
                   this.mediaPlayed = true;
                   
                   this.promptPlayback =  false;
                }

                if( e.key === "vg-favorite"){
                    let metaToDispatch : object;
                    if(this.meta.obj_type == "Episode" && this.meta.video ){
                        metaToDispatch = this.meta.video.meta;//.unique_id
                    }else if( this.meta.obj_type == "Video"){
                        metaToDispatch = this.meta;//.unique_id
                    }
                    const favoriteObj : any = {
                        add : e.message,
                        item : {
                            meta: metaToDispatch
                        }
                    }
                    this.coreEffects.addOrRemoveFavorite(favoriteObj);
                }

                if (e.key === "theatremode") {
                    this.isTheatreMode = e.message.theatre            
                    this.playerService.setTheaterModeState(this.isTheatreMode);
                }
            });
        }
    }

    setActiveMedia = () => {     
        if (!this.playPause) {            
            setTimeout(this.setActiveMedia.bind(this), 200);
            return;
        }
        
        this.isCasting = this.activeMedia == "vgChromecastMedia";

        if (this.isCasting && !this.cMedia) {
            this.cMedia = this.api.getMediaById('vgChromecastMedia');
            this.cMedia.subscriptions.volumeChange.debounceTime(250).takeUntil(this.ngUnsubscribe).subscribe((e) => {            
                this.playerService.setVolumeState(this.cMedia.volume);
            }); 
        }

        if (this.playPause && this.playPause.vgFor != this.activeMedia) {
            this.playPause.vgFor = this.activeMedia;
        }
        if (this.current && this.current.vgFor != this.activeMedia) {
            this.current.vgFor = this.activeMedia;
        }
        if (this.total && this.total.vgFor != this.activeMedia) {
            this.total.vgFor = this.activeMedia;
        }
        if (this.overlayPlay && this.overlayPlay.vgFor != this.activeMedia) {
            this.overlayPlay.vgFor = this.activeMedia;
        }
        if (this.scrubBar && this.scrubBar.vgFor != this.activeMedia) {
            this.scrubBar.vgFor = this.activeMedia;
        }
        if (this.scrubTime && this.scrubTime.vgFor != this.activeMedia) {
            this.scrubTime.vgFor = this.activeMedia;
        }
        if (this.bufferTime && this.bufferTime.vgFor != this.activeMedia) {
            this.bufferTime.vgFor = this.activeMedia;
        }
        if (this.volume && this.volume.vgFor != this.activeMedia) {
            this.volume.vgFor = this.activeMedia;
        }
        if (this.mute && this.mute.vgFor != this.activeMedia) {
            this.mute.vgFor = this.activeMedia;
        }
        if (this.vidPoster && this.vidPoster.vgFor != this.activeMedia) {
            this.vidPoster.vgFor = this.activeMedia;
        }
        if(this.playPause)
            this.playPause.onPlayerReady();
        
        if(this.current)
            this.current.onPlayerReady();
        
        if(this.total)
            this.total.onPlayerReady();

        if(this.overlayPlay)
            this.overlayPlay.onPlayerReady();

        if(this.volume)
            this.volume.onPlayerReady();

        if(this.mute)
            this.mute.onPlayerReady();

        if(this.bufferTime)
            this.bufferTime.onPlayerReady();

        if(this.scrubTime)
            this.scrubTime.onPlayerReady();

        if(this.scrubBar)
            this.scrubBar.onPlayerReady();

        if(this.vidPoster)
            this.vidPoster.onPlayerReady();

        this.restorePlayerControlStates();

        this.cd.detectChanges();
    }

    ngOnChanges( changes ){
        if( changes.prevPercentPlayed  && changes.prevPercentPlayed.currentValue != null){
            if( this.prevPercentPlayed < this.settings['VIDEO_COMPLETE_RATIO'] && this.prevPercentPlayed > 0){
                this.requiresPrompt = true;
            }
        }
    }

    onPlayerReady(api: VgAPI) {
        this.api = api;
        this.media = this.api.getMediaById('singleVideo');
        
        // set default control states
        this.restorePlayerControlStates()

        this.interactions.next({ key: "setMedia", message: { media: this.media } });
        this.logo = this.settings['CLIENT_LOGO'];
        this.media.subscriptions.canPlay.takeUntil(this.ngUnsubscribe).subscribe(() => {
            const notPreviousPlay = this.prevDurationWatched  == null && this.prevPercentPlayed  == null;
            const completionRatio = this.settings['VIDEO_COMPLETE_RATIO'];
            const returnOrComplete = notPreviousPlay || this.prevPercentPlayed >= completionRatio || this.prevPercentPlayed == 0;
            //console.log(`autoplay=${this.autoPlay},isplaying=${this.playing},iscasting=${this.isCasting}, needsCasting=${this.needsCasting}`)
            if (this.autoPlay && this.currentStream) {                
                if (this.isClient && this.route.snapshot.queryParams.t && !this.playing && !this.isCasting) {
                    this.media.seekTime(Number(this.route.snapshot.queryParams.t));
                    if(this.api.medias['vgChromecastMedia']) {
                        this.api.medias['vgChromecastMedia'].state = "playing";
                    }
                    this.media.play();
                    this.mediaPlayed = true;
                } 
                else if (this.isClient && !this.embed && !this.playing && (!this.isCasting && !this.needsCasting) && !returnOrComplete && this.requiresPrompt) {
                    this.promptPlayback = true;
                    this.requiresPrompt = false;
                }
                else if (this.isClient && !this.embed && !this.playing && !this.isCasting && returnOrComplete) {
                    if (this.autoplay) {
                        if(this.api.medias['vgChromecastMedia'])
                            this.api.medias['vgChromecastMedia'].state = "playing";
                            
                        this.media.play();
                        this.mediaPlayed = true;
                    }
                    else {
                        this.isCasting = true;
                        this.cd.detectChanges();
                        this.inTransition = true;
                        this.media.play();
                        this.mediaPlayed = true;
                        //this.media.pause();
                        if (this.needsCasting && (!this.startCastingDispatched)) {
                            this.needsCasting = false;
                            this.startCastingDispatched = true;
                            this.interactions.next({ key: "startCasting", message: { startCasting: true } });
                        }
                    }
                }
            }
        });

        this.media.subscriptions.playing.takeUntil(this.ngUnsubscribe).subscribe(() => {
            if (!this.playing) {
                this.playing = true;
                this.ended = false;
                let category = this.embed ? "EmbedVideo" : "VODVideo";
                let currentMedia = this.media;
                if (this.isLive)
                    category = "LiveVideo";

                if (this.isCasting)
                {
                    category = "Cast" + category;
                    currentMedia = this.cMedia;
                }

                if (this.inTransition){
                    return;
                }

                this.analytics.eventTrack("start", {
                    event: 'videoEvent',
                    category: category,
                    label: this.slug,
                    duration: Math.floor(currentMedia.duration),
                    currentTime: Math.floor(currentMedia.currentTime)
                });          
            }
        });

        this.media.subscriptions.pause.takeUntil(this.ngUnsubscribe).subscribe(() => {

            let category = this.embed ? "EmbedVideo" : "VODVideo";
            let currentMedia = this.media;
            if (this.isLive)
                category = "LiveVideo";

            if(this.isCasting)
            {
                currentMedia = this.cMedia;
                category = "Cast" + category;
            }   
            
            if(this.inTransition){
                return;
            }

            this.analytics.eventTrack("pause", {
                event: 'videoEvent',
                category: category,
                label: this.slug,
                duration: Math.floor(currentMedia.duration),
                currentTime: Math.floor(currentMedia.currentTime)
            })

        });

        this.media.subscriptions.ended.takeUntil(this.ngUnsubscribe).subscribe(() => {
            let category = this.embed ? "EmbedVideo" : "VODVideo";
            let currentMedia = this.media;

            if (this.isLive)
                category = "LiveVideo";

            if(this.isCasting)
            {
                currentMedia = this.cMedia;
                category = "Cast" + category;
            }

            //this.percentPlayed = 0.05;
            this.playing = false;
            
            if(this.ended || this.inTransition){
                return;
            }

            this.ended = true;
            //this.hlsRef.hls.coreComponents = [];

            this.analytics.eventTrack("end", {
                event: 'videoEvent',
                category: category,
                label: this.slug,
                duration: Math.floor(currentMedia.duration),
                currentTime: Math.floor(currentMedia.currentTime)
            });
        });

        this.media.subscriptions.timeUpdate.takeUntil(this.ngUnsubscribe).subscribe(() => {
            let category = this.embed ? "EmbedVideo" : "VODVideo";
            let currentMedia = this.media;

            if(this.ended || this.inTransition){
                return;
            }
            if (this.isLive)
                category = "LiveVideo";

            if(this.isCasting)
            {
                currentMedia = this.cMedia;
                category = "Cast" + category;
            }

            if(!this.isLive)
            {
                let currentTime = Math.floor(currentMedia.currentTime);
                let totalTime = Math.floor(currentMedia.duration)
                let duration = Math.floor(currentMedia.duration)
                this.timestamp = Math.floor(currentMedia.currentTime);
                if ( !this.percentPlayed ){
                    this.percentPlayed = 0.05;
                }
                if (totalTime > 0 && (currentTime / totalTime) > this.percentPlayed && this.percentPlayed < 1) {
                    this.analytics.eventTrack("PercentPlayed" + (this.percentPlayed * 100).toFixed(0), {
                        event: 'videoEvent',
                        category: category,
                        label: this.slug,
                        duration: duration,
                        currentTime: currentTime
                    })

                    this.percentPlayed += 0.05;
                }
            }
            else{
                let currentTime = Math.floor(currentMedia.currentTime);
                if(currentTime - this.liveDurationWatched >= 30 && currentTime != 0)
                {
                    this.analytics.eventTrack("30 Seconds Played", {
                        event: 'videoEvent',
                        category: category,
                        label: this.slug,
                        currentTime: currentTime
                    })
                    this.liveDurationWatched = currentTime;
                }
            }
            
        });

        this.media.subscriptions.seeked.takeUntil(this.ngUnsubscribe).subscribe(() => {
            if(this.playing)
            {
                let category = this.embed ? "EmbedVideo" : "VODVideo";
                let currentMedia = this.media;

                if (this.isLive)
                    category = "LiveVideo";
    
                if(this.isCasting)
                {
                    currentMedia = this.cMedia;
                    category = "Cast" + category;
                }   
                
                if(this.inTransition){
                    return;
                }
    
                this.analytics.eventTrack("Seek", {
                    event: 'videoEvent',
                    category: category,
                    label: this.slug,
                    duration: Math.floor(currentMedia.duration),
                    currentTime: Math.floor(currentMedia.currentTime)
                })    
            }            
        });

        this.media.subscriptions.volumeChange.debounceTime(250).takeUntil(this.ngUnsubscribe).subscribe((e) => {            
            this.playerService.setVolumeState(this.media.volume);
        });        
    }

    public initializeCastApi() {        
        if (typeof chrome != 'undefined' && (!chrome.cast || !chrome.cast.isAvailable)) {
            if (this.connectionAttempts > 0) {
                this.connectionAttempts -= 1;
                
                setTimeout(this.initializeCastApi.bind(this), 200);
            }
            else {
                
                this.isChrome = false;
            }
            return;
        }
        if (1 == 1) {
            let options = {};
            var apiConfig, appId, sessionRequest;
            
            appId = this.settings['CHROMECAST_RECEIVER_ID'];
            try{
                cast.framework.CastContext.getInstance().setOptions({
                    receiverApplicationId: appId,
                    autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED
                });
                this.onInitSuccess();
            }
            catch(e){

            }
        }
        else { }
        //this.chromeCastInited = true;
    }

    private onInitSuccess = function () {
        let castContext = cast.framework.CastContext.getInstance();
        let existingSession = castContext.getCurrentSession();
        if (existingSession) {
            this.previousSession = true;
        }
        castContext = null;
        existingSession = null;
        this.chromeCastInited = true;
    };

    private castError = function (castError) {
        //return console.log('Cast Error: ' + (JSON.stringify(castError)));
    };

    private sessionJoinedListener(session) {
        //return console.log('Session joined');
    }

    private receiverListener = function (availability) {        
        if (availability === 'available') {
            this.canCast = true;
        }
    }

    private get currentActiveMedia(): string {
        return this.activeMedia;
    }

    private get currentStream(): string {
        if (this.hlsSupported || this.flashInstalled) {
            return this.sources && this.sources.length > 0 && this.sources[0].url;
        }
        else {
            return this.fallback.url;
        }
    }

    private get autoPlay(): boolean {
        if (this.embed) {
            return false;
        }
        else {
            return true;
        }
    }

    private siteLink(): string {
        let link = "";
        if (this.isClient) {
            link = window.location.origin + window.location.pathname.replace('/embed', '');
        }
        return link;
    }

    private get hlsSupported(): boolean {
        return (Hls && Hls.isSupported()) || this.deviceInfo.isMobile;
    }

    private get fallback(): any {
        return this.sources && this.sources.find(s => s.type === "fallback")
    }

    public get isLive(): boolean {
        if (this.meta && this.meta.obj_type) {
            if(this.meta.obj_type === "Stream")
            {
                this.coreEffects.setInternalStateValue("liveVideo", true);
            }
            return this.meta.obj_type === "Stream";
        }
        else {
            this.coreEffects.setInternalStateValue("liveVideo", false);
            return false;
        }
    }

    private get seriesLogo(): string {
        let logo = ""
        if (this.meta.series && this.meta.series.logo) {
            logo = this.meta.series.url;
        }
        return logo;
    }

    ngOnInit() {
        if (this.isClient) {
            this.likeStatus = this.meta["liked"];

            if(!this.isLive)
            {
                this.duration = (this.meta.duration) ? this.meta.duration : this.meta.video.meta.duration;
            }
            
            if (this.duration >= 3600){
                this.timeFormat = "hh:mm:ss";
            }
            else{
                this.timeFormat = "mm:ss";
            }
            if (this.isChrome) {                
                const stateCastingState = this.coreEffects.getInternalStateValue('isChromeCast');
                if (stateCastingState) {
                    if (stateCastingState == true || stateCastingState == 'true') {
                        this.needsCasting = true;
                        //this.activeMedia = "vgChromecastMedia";
                        this.autoplay = false;
                    }
                    else {
                        this.needsCasting == false;
                        //this.activeMedia = "singleVideo";
                        this.autoplay = true;
                    }
                }
                else {
                    if (this.previousSession) {
                        this.needsCasting == true;
                        //this.activeMedia = "vgChromecastMedia";
                        this.previousSession = false;
                        this.autoplay = false;
                    }
                    else {
                        this.needsCasting == false;
                        //this.activeMedia = "singleVideo";
                        this.autoplay = true;
                    }
                }
//                 if (this.activeMedia == "vgChromecastMedia") {
//                     this.setActiveMedia();
//                 }
            }
            else {
                this.autoplay = true;
            }
            this.activeMedia = "singleVideo";
            //this.duration = this.meta.duration;
        }        
    }

    ngAfterViewInit() {
        if (this.isChrome) {
            this.initializeCastApi();
            this.cCastSubscription = this.interactions.subscribe(e => {
                if (e.key == "castingChange") {                    
                    this.isCasting = e.message.activeMedia == "vgChromecastMedia";
                    this.activeMedia = e.message.activeMedia;
                    this.cd.detectChanges();
                    this.setActiveMedia();
                    
                    if (this.inTransition) {
                        this.inTransition = false;
                    }

                    let category = this.isLive ? "LiveVideo" : this.embed ? "EmbedVideo" : "VODVideo";

                    if (this.isCasting) {
                        category = "Cast" + category;
                        this.analytics.eventTrack("StartCast", {
                            event: 'videoEvent',
                            category: category,
                            label: this.slug,
                            duration: Math.floor(this.media.duration),
                            currentTime: Math.floor(this.media.currentTime)
                        });
                    }
                    else {
                        this.analytics.eventTrack("StopCast", {
                            event: 'videoEvent',
                            category: category,
                            label: this.slug,
                            duration: Math.floor(this.media.duration),
                            currentTime: Math.floor(this.media.currentTime)
                        });
                    }
                }
            });            
        }

        if (this.isTheatreMode && this.theatreControl) { 
            this.theatreControl.changeTheatremodeState(false);
        }
    }

    private destroyControl(c : any){
        if (c){
            c.ngOnDestroy();
        }
    }

    private get durationWatched() : number{
        let ts: number;
        if ( !this.mediaPlayed &&  this.prevDurationWatched != null){
            ts = this.prevDurationWatched
        }else {
            ts = this.timestamp
        }

        return ts
    }
    private updateVideoStats(){
        let slug;
        let uniqueId;
        let statObj : object = {};
        const currentTime = Math.floor(this.media.time.current) > 0 ? Math.floor(this.media.time.current) : 1;
        const percentPlayed = Number((currentTime / Math.floor(this.media.time.total)).toFixed(2));
        if(this.meta.obj_type == "Episode" && this.meta.video ){
            uniqueId = this.meta.video.meta.unique_id
            slug = this.meta.video.meta.slug

        }else if( this.meta.obj_type == "Video"){
            uniqueId = this.meta.unique_id
            slug = this.meta.slug
        }
        statObj[uniqueId] = {meta: {
            slug: slug,
            duration_watched: this.durationWatched,
            percent_played: percentPlayed ,
            complete: percentPlayed > this.settings['VIDEO_COMPLETE_RATIO'],
            rating: null,
            unique_id: uniqueId
        }};

        if (this.likeStatus != undefined ){
            statObj[uniqueId].meta.liked = this.likeStatus;
        }else {
            statObj[uniqueId].meta.liked = null;
        }

        this.coreEffects.updateVideoStats(statObj);
        if (  this.userLogin.isLoggedIn ){
            this.coreEffects.processExistingUserVideoStats()
            .first()
            .subscribe(pushed => {
                
              });
        }
    }

    ngOnDestroy() {
        if (this.isClient){
            if (this.cCastSubscription) {
                this.cCastSubscription.unsubscribe();
                this.cCastSubscription = null;
            }
            if (this.autoplaySubscription) {
                this.autoplaySubscription.unsubscribe();
                this.autoplaySubscription = null;
            }

            if (this.ngUnsubscribe) {
                this.ngUnsubscribe.next();
                this.ngUnsubscribe.complete();
                this.ngUnsubscribe.unsubscribe();
                this.ngUnsubscribe = null;
            }
            
            this.updateVideoStats();
            
            this.destroyControl(this.playPause);
            this.destroyControl(this.current);
            this.destroyControl(this.total);
            this.destroyControl(this.overlayPlay);
            this.destroyControl(this.scrubBar);
            this.destroyControl(this.scrubTime);
            this.destroyControl(this.bufferTime);
            this.destroyControl(this.volume);
            this.destroyControl(this.mute);
            this.destroyControl(this.vidPoster);  

            if (this.media){
                if (this.media.state && this.media.state != VgStates.VG_ENDED){
                  this.media.elem.dispatchEvent(new CustomEvent(VgEvents.VG_ENDED));
                  this.media.state = VgStates.VG_ENDED;
                }
                this.api.unregisterMedia(this.media);
                //this.media.ngOnDestroy();
            }
    
            if (this.cMedia){
                if (this.cMedia.state && this.cMedia.state != VgStates.VG_ENDED){
                  this.cMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_ENDED));
                  this.cMedia.state = VgStates.VG_ENDED;
                }
                this.api.unregisterMedia(this.cMedia);
            }
    
            if (this.api){
                this.api.medias = {};
            }

            this.video = null;
            this.media = null;
            this.cMedia = null;
            this.sources = null;
            this.api = null;

            this.coreEffects.setInternalStateValue("liveVideo", false);
        }
    }

    restorePlayerControlStates() {
        const controlState = this.playerService.getPlayerControlState();
        if (controlState) {
            this.api.volume = controlState.volumeLevel;
            this.isTheatreMode = controlState.isTheaterMode;         
        }
    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/video-player.component.ts